import {ValidationErrorKeys} from '@hconnect/common/consts'
import {TFunction} from 'i18next'
import {object, string} from 'yup'

export const getJobsToBeDoneInsightFormValidationSchema = ({t}: {t: TFunction}) =>
  object().shape({
    description: string().required(t(ValidationErrorKeys.REQUIRED))
  })
